import * as React from 'react';
import AddinEntryButtonListView from './AddinEntryButtonListView';
import OverflowMenuView from './OverflowMenuView';
import { getAdapter } from 'owa-addins-apis';
import { observer } from 'mobx-react';
import {
    Addin,
    EnabledAddinCommands,
    ExtensibilityHostItem,
    extensibilityState,
} from 'owa-addins-store';
import { ExtensibilityModeEnum } from 'owa-addins-types';

const divStyle = require('./AddinBarView.scss');

const DefaultMaxVisibleAddinsCount = 5;

const MaxVisibleAddinsCountOnRead = 3;

const MaxVisibleAddinsCountOnCompose = 5;

export interface AddinBarViewProps {
    Index: string;
}

@observer
export default class AddinBarView extends React.Component<AddinBarViewProps, any> {
    private getMaxVisibleAddinsCount(mode: ExtensibilityModeEnum): number {
        switch (mode) {
            case ExtensibilityModeEnum.MessageRead:
                return MaxVisibleAddinsCountOnRead;
            case ExtensibilityModeEnum.MessageCompose:
                return MaxVisibleAddinsCountOnCompose;
            default:
                return DefaultMaxVisibleAddinsCount;
        }
    }

    render() {
        const hostItem: ExtensibilityHostItem = extensibilityState.HostItems.get(this.props.Index);
        const enabledAddinCommands: EnabledAddinCommands = extensibilityState.EnabledAddinCommands;

        if (!hostItem) {
            return <div />;
        }

        const adapter = getAdapter(this.props.Index);
        let maxVisibleAddinsCount = this.getMaxVisibleAddinsCount(adapter.mode);
        const existingAddinCommands = enabledAddinCommands.getExtensionPoint(adapter.mode);

        maxVisibleAddinsCount = Math.min(maxVisibleAddinsCount, existingAddinCommands.length);
        let overflowMenu: JSX.Element = null;
        if (maxVisibleAddinsCount < existingAddinCommands.length) {
            overflowMenu = (
                <OverflowMenuView
                    hostItemIndex={this.props.Index}
                    addins={
                        existingAddinCommands.slice(
                            maxVisibleAddinsCount,
                            existingAddinCommands.length
                        ) as Addin[]
                    }
                />
            );
        }

        return (
            <div className={divStyle.divContainer}>
                <AddinEntryButtonListView
                    hostItemIndex={this.props.Index}
                    addins={existingAddinCommands.slice(0, maxVisibleAddinsCount) as Addin[]}
                />
                {overflowMenu}
            </div>
        );
    }
}
